(function () {
  let swiperPopularProducts;
  const updateNavPosition = (section) => {
    const nav = section.querySelector(".popular-products-nav");
    if (!nav) return;
    const firstSlide = section.querySelector(".popular-products-item");
    if (!firstSlide) return;
    const imgWrapper = firstSlide.querySelector(".card");
    if (!imgWrapper) return;
    const swiperEl = section.querySelector(".popular-products-layout");
    const swiperRect = swiperEl.getBoundingClientRect();
    const imgRect = imgWrapper.getBoundingClientRect();
    const offsetTop = imgRect.top - swiperRect.top;
    const centerY = offsetTop + imgRect.height / 2;
    nav.style.top = `${centerY}px`;
  };
  const initSlider = (section) => {
    if (!section || !section?.classList.contains("popular-products-section"))
      return;
    const swiperEl = section.querySelector(".popular-products-layout");
    const swiperWrapper = section.querySelector(".popular-products-list");
    const slides = section.querySelectorAll(".popular-products-item");
    if (!swiperEl || !swiperWrapper || !slides || !slides.length) return;
    swiperEl.classList.add("swiper");
    swiperWrapper.classList.add("swiper-wrapper");
    slides.forEach((slide) => slide.classList.add("swiper-slide"));
    const prevBtn = section.querySelector(".popular-products-nav-button--prev");
    const nextBtn = section.querySelector(".popular-products-nav-button--next");
    const columns = Number(swiperEl.dataset.columns) || 3;
    const isCenteredSlides = Boolean(swiperEl.dataset.centeredSlides);
    const isLoop = Boolean(swiperEl.dataset.loop);
    const breakpointsConfig = {
      2: {
        576: { slidesPerView: 2.1, spaceBetween: 20 },
        990: { slidesPerView: 2.1, spaceBetween: 24 },
      },
      3: {
        576: { slidesPerView: 2.1, spaceBetween: 20 },
        990: { slidesPerView: 3.15, spaceBetween: 24 },
      },
      4: {
        576: { slidesPerView: 2.1, spaceBetween: 20 },
        990: { slidesPerView: 3.15, spaceBetween: 24 },
        1360: { slidesPerView: 4.15, spaceBetween: 24 },
      },
    };
    const centeredSlidesBreakpointsConfig = {
      576: { slidesPerView: 1.5, spaceBetween: 20 },
      990: { slidesPerView: 3.15, spaceBetween: 24 },
    };
    const sliderOptions = {
      slidesPerView: 1.15,
      spaceBetween: 16,
      speed: 800,
      allowTouchMove: true,
      loop: isLoop,
      centeredSlides: isCenteredSlides,
      centeredSlidesBounds: isCenteredSlides,
      breakpoints: isCenteredSlides
        ? centeredSlidesBreakpointsConfig
        : breakpointsConfig[columns],
      mousewheel: {
        forceToAxis: true,
      },
      a11y: {
        scrollOnFocus: false,
      },
      preventClicks: true,
      navigation:
        nextBtn && prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
              disabledClass: "swiper-button-disabled",
            }
          : false,
    };
    swiperPopularProducts = new Swiper(swiperEl, sliderOptions);
    updateNavPosition(section);
    const nav = section.querySelector(".popular-products-nav");
    if (nav) {
      nav.classList.add("popular-products-nav--visible");
    }
  };
  const destroySlider = (section) => {
    if (!swiperPopularProducts || !section) return;
    const swiperEl = section.querySelector(".popular-products-layout");
    const swiperWrapper = section.querySelector(".popular-products-list");
    const slides = section.querySelectorAll(".popular-products-item");
    if (!swiperEl || !swiperWrapper || !slides || !slides.length) return;
    swiperPopularProducts.destroy(true, true);
    swiperPopularProducts = null;
    swiperEl.classList.remove("swiper");
    swiperWrapper.classList.remove("swiper-wrapper");
    slides.forEach((slide) => slide.classList.remove("swiper-slide"));
  };
  const initPopularProducts = (section) => {
    if (!section || !section?.classList.contains("popular-products-section"))
      return;
    const mainContainer = section.querySelector(".popular-products");
    const desktopLayout = mainContainer.dataset.layout;
    const mobileLayout = mainContainer.dataset.layoutMobile;
    let currentLayout = null;
    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      let newLayout;
      if (entry.contentRect.width < 576) {
        newLayout = mobileLayout;
      } else {
        newLayout = desktopLayout;
      }
      if (newLayout !== currentLayout) {
        if (swiperPopularProducts) {
          destroySlider(section);
        }
        if (newLayout === "slider") {
          initSlider(section);
        }
        currentLayout = newLayout;
      }
      if (currentLayout === "slider") {
        updateNavPosition(section);
      }
    });
    sectionResizeObserver.observe(section);
  };
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("popular-products-section")) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  const initSimpleLoadMore = (section) => {
    if (!section || !section.querySelectorAll) return;
    section
      .querySelectorAll(".popular-products-load-more--simple")
      .forEach((btn) => {
        if (btn.dataset.simpleLoadMoreInit) return;
        btn.dataset.simpleLoadMoreInit = "true";
        btn.addEventListener("click", () => {
          const list = btn
            .closest(".popular-products-main")
            ?.querySelector(".popular-products-list");
          if (!list) return;
          list.classList.remove("is-limited");
          btn.hidden = true;
        });
      });
  };

  initPopularProducts(document.currentScript.parentElement);
  initHeadingAnimation(document.currentScript.parentElement);
  initSimpleLoadMore(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initPopularProducts(event.target);
    initHeadingAnimation(event.target);
    initSimpleLoadMore(event.target);
  });
})();
